import {
  SYNC_CONCURRENCY_HELP,
  getPreviewRecipientKey,
  isRegisteredPreviewSend,
  type DecisionEngineDestinationDefinition,
} from "./definition";
import { hightouchPayloadMapping } from "./sync-config-helpers";

export const iterableDefinition: DecisionEngineDestinationDefinition = {
  destinationType: "iterable",
  category: "trigger",
  generateSyncConfig: ({
    producer,
    channelType,
    settings,
    isPreview,
    sendToHightouchUser,
    previewRecipientMode,
    messageTags,
  }) => {
    const typeMap: Record<string, string> = {
      push: "trigger-push",
      email: "trigger",
      inapp: "trigger-in-app",
    };
    const registeredPreview = isRegisteredPreviewSend({
      isPreview,
      previewRecipientMode,
    });
    const previewRecipientKey = getPreviewRecipientKey(settings);
    const config: Record<string, unknown> = {
      type: typeMap[channelType],
      campaignId: { type: "standard", from: "campaign_id" },
      mappings: [hightouchPayloadMapping({ producer, messageTags })],
      ...(registeredPreview ? { allowRepeatMarketingSends: true } : {}),
    };
    if (registeredPreview && previewRecipientKey) {
      // Projects with non-unique emails reject every email-keyed API call
      // ("Cannot use email in API calls..."), so key the send on the
      // customer's one test profile instead — its email attribute is the
      // account preview address, which is where the mail actually lands.
      config.userId = {
        type: "static",
        value: previewRecipientKey,
        valueType: "STRING",
      };
    } else if (registeredPreview) {
      // The registered recipient is the account address itself — an email —
      // so registered sends are email-keyed even on userId channels (whose
      // external_id would otherwise be sent as a nonexistent user ID).
      config.email = { type: "standard", from: "external_id" };
    } else if (
      settings.recipientType === "userId" &&
      !(isPreview && sendToHightouchUser)
    ) {
      config.userId = { type: "standard", from: "external_id" };
    } else {
      config.email = { type: "standard", from: "external_id" };
    }
    return config;
  },
  // The Iterable trigger sync reads both keys at runtime (defaults 50 / 5);
  // the rETL form sets no cap, so these bounds just keep overrides sane.
  syncTuning: {
    batchSize: {
      defaultValue: 50,
      configKey: "rowsPerBatch",
      max: 1000,
      label: "Processing batch size",
      description:
        "Multiplied by concurrency to set rows processed before saving progress. Each request sends one recipient.",
    },
    parallelization: {
      defaultValue: 5,
      max: 100,
      label: "Concurrent requests",
      description: "Controls how many recipient send requests run in parallel.",
      help: SYNC_CONCURRENCY_HELP,
    },
  },
};
